import {createRouter, createWebHashHistory} from 'vue-router';
import Trips from '@/components/pages/Trips';
import Login from '@/components/Login';
import store from './vuex';
import {actions, mutations} from '@/assets/js/vue/vuex/actions';
import paths from '@/assets/js/vue/router/paths';
import CarFleet from '@/components/pages/CarFleet';
import ContentHolder from '@/components/ContentHolder';
import EcoEvents from '@/components/pages/EcoEvents';
import Garage from '@/components/pages/Garage';
import TeltonikaDecoder from '@/components/pages/TeltonikaDecoder';
import OnBoard from '@/components/pages/OnBoard';
import EventsPage from "@/components/pages/events/EventsPage.vue";
import Client from '@/components/pages/Client.vue';
import GeoFencesPage from "@/components/pages/geo-fences/GeoFencesPage.vue";
import ReportsPage from "@/components/pages/reports/ReportsPage.vue";
import EditTaskPage from "@/components/pages/task-planning/EditTaskPage.vue";
import AllTasksPage from "@/components/pages/task-planning/AllTasksPage.vue";
import ViewOnlyTaskPage from "@/components/pages/task-planning/ViewOnlyTaskPage.vue";
import TaskSchedulesPage from "@/components/pages/task-planning/TaskSchedulesPage.vue";
import DashboardPage from "@/components/pages/dashboard/DashboardPage.vue";
import OazisSuppliersMapPage from "@/components/pages/dashboard/OazisSuppliersMapPage.vue";
import usersConfig from "@/assets/js/users-config.ts";

const routes = [
  {name: 'Dashboard', path: paths.home, component: DashboardPage},
  {name: 'oazis-suppliers-map', path: paths.oazisSuppliersMap, component: OazisSuppliersMapPage},
  {name: 'Login', path: paths.auth, component: Login},
  {
    name: 'Reports',
    path: '/reports',
    component: ContentHolder,
    children: [
      {name: 'Reports', path: 'page', component: ReportsPage},
      {name: 'Trips', path: 'trips', component: Trips},
      {name: 'EcoEvents', path: 'eco-events', component: EcoEvents},
      {name: 'Events', path: 'events', component: EventsPage},
    ],
  },
  {name: 'Garage', path: '/garage', component: Garage},
  {
    name: 'Settings',
    path: '/settings',
    component: ContentHolder,
    children: [
      {name: 'OnBoard', path: 'on-board', component: OnBoard},
      {name: 'CarFleet', path: 'car-fleet', component: CarFleet},
      {name: 'Client', path: 'client', component: Client},
    ],
  },
  {name: 'GeoFences', path: '/geo-fences', component: GeoFencesPage},
  {
    name: 'TaskPlanner',
    path: '/task-planner',
    component: ContentHolder,
    children: [
      {name: 'NewTask', path: 'new-task', component: EditTaskPage},
      {name: 'ViewOnlyTask', path: 'view-only/:id', component: ViewOnlyTaskPage, props: true},
      {name: 'AllTasks', path: 'all-tasks', component: AllTasksPage},
      {name: 'TaskSchedules', path: 'schedules', component: TaskSchedulesPage},
    ],
  },
  {
    name: 'TeltonikaDecoder',
    path: '/teltonika-decoder',
    component: TeltonikaDecoder,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (paths.guestModePageNames.includes(to.name)) {
    store.commit(mutations.SET_GUEST_MODE, true);
    next();
    return;
  }

  let isLogged = store.getters.isLogged;
  let isOnLoginPage = to.fullPath === paths.auth;

  if (isOnLoginPage && isLogged) {
    next({path: usersConfig.getUserHome(store.getters.userId)});
    return;
  } else if (!isOnLoginPage && !isLogged) {
    store.dispatch(actions.GET_SESSION).then(() => {
      isLogged = store.getters.isLogged;

      if (!isLogged) {
        next({path: paths.auth});
        return;
      }

      if (!usersConfig.isPathAllowed(store.getters.userId, to.fullPath)) {
        next({path: usersConfig.getUserHome(store.getters.userId)});
        return;
      }

      next();
    });

    return;
  }

  let isAdmin = store.getters.isAdmin;

  if (!isAdmin && paths.adminWall.includes(to.fullPath)) {
    next({path: paths.home});
    return;
  }

  if (!usersConfig.isPathAllowed(store.getters.userId, to.fullPath)) {
    next({path: usersConfig.getUserHome(store.getters.userId)});
    return;
  }

  next();
});

export default router;
